import { CloseOutlined } from '@ant-design/icons';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { BillingLimitsModalProps } from '@mm/state/modules/modalsState/props';
import { selectIsShopifyContext } from '@mm/state/selectors/viewSelectors';
import { InputNumber, Radio } from 'antd';
import React, { useState } from 'react';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';
import styles from './BillingLimitsModal.module.css';
import { useSelector } from 'react-redux';

export const BillingLimitsModal = ({
  title,
  description,
  inputFormatterFn,
  defaultValue,
  minValue = 1,
  onSubmit,
  limitComponent,
}: BillingLimitsModalProps) => {
  const isShopify = useSelector(selectIsShopifyContext);

  const [limitOption, setLimitOption] = useState<number>(
    defaultValue || isShopify ? 2 : 1,
  );
  const hasLimit = limitOption === 2;

  const [limitValue, setLimitValue] = useState<number | null>(
    defaultValue || null,
  );
  const invalidInput = !limitValue || limitValue < minValue;
  const { closeModal } = useModalActions();

  const onChangeLimitOption = (val: number) => {
    setLimitOption(val);
    if (val === 1) {
      setLimitValue(null);
    }
  };

  return (
    <div className={styles.container}>
      <CloseOutlined
        className={styles.closeIcon}
        onClick={() => closeModal()}
      />

      <div className={styles.title}>
        {title}
        {description && <div className={styles.description}>{description}</div>}
      </div>

      <div className={styles.inputWrapper}>
        <Radio.Group
          onChange={e => onChangeLimitOption(e.target.value)}
          value={limitOption}
          buttonStyle="outline"
        >
          <div className={styles.radioInputs}>
            {!isShopify && (
              <Radio value={1} className={styles.radioInput}>
                No Limit
                <span className={styles.recommended}>Highly recommended</span>
              </Radio>
            )}

            <div className={styles.limitedRadioInputWrapper}>
              <Radio value={2} className={styles.radioInput}>
                Set a limit
              </Radio>
              <div className={styles.numberInputWithMsg}>
                {hasLimit ? (
                  <InputNumber
                    min={minValue}
                    status={invalidInput ? 'error' : ''}
                    formatter={value =>
                      inputFormatterFn
                        ? inputFormatterFn(value)
                        : `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    value={limitValue}
                    onChange={val => {
                      setLimitValue(val);
                    }}
                  />
                ) : null}

                {hasLimit && limitComponent}
              </div>
            </div>
          </div>
        </Radio.Group>
      </div>
      <div className={styles.buttonsWrapper}>
        <PrimaryButton
          onClick={() => closeModal()}
          className={styles.cancelButton}
          color="secondary-blue"
        >
          Cancel
        </PrimaryButton>
        <PrimaryButton
          onClick={() => onSubmit(limitValue)}
          className={styles.button}
          disabled={hasLimit && invalidInput}
        >
          Set up new Limit
        </PrimaryButton>
      </div>
    </div>
  );
};
